import { useState, useEffect } from "react";
import { Menu, X, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_pronto-intervento-1/artifacts/jrz52610_WhatsApp_Image_2026-04-13_at_6.31.18_PM-removebg-preview.png";
const LOGO_URL_LIGHT = "https://customer-assets.emergentagent.com/job_pronto-intervento-1/artifacts/ofmhj622_ss%20logo.png";

const navLinks = [
  { href: "#servizi", label: "Servizi" },
  { href: "#chi-siamo", label: "Chi Siamo" },
  { href: "#galleria", label: "Galleria" },
  { href: "#testimonianze", label: "Testimonianze" },
  { href: "#preventivo", label: "Preventivo" },
  { href: "#contatti", label: "Contatti" },
];

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNavClick = (e, href) => {
    e.preventDefault();
    setIsMobileMenuOpen(false);
    const element = document.querySelector(href);
    if (element) {
      const offset = 80;
      const top = element.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: "smooth" });
    }
  };

  return (
    <header
      className="fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-white border-b border-[#e5e7eb] shadow-sm"
      data-testid="header"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <a href="#" className="flex-shrink-0" data-testid="logo-link">
            <img
              src={LOGO_URL}
              alt="Scavone Service E&J"
              className="h-10 w-auto"
              data-testid="logo-image"
            />
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-8" data-testid="desktop-nav">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => handleNavClick(e, link.href)}
                className="nav-link text-[#29383d] font-medium hover:text-[#5abb3d] transition-colors"
                data-testid={`nav-link-${link.href.replace('#', '')}`}
              >
                {link.label}
              </a>
            ))}
          </nav>

          {/* CTA Button */}
          <div className="hidden lg:flex items-center gap-4">
            <a
              href="tel:+393292656988"
              className="flex items-center gap-2 text-[#29383d] font-medium hover:text-[#5abb3d] transition-colors"
              data-testid="phone-link"
            >
              <Phone className="w-4 h-4" />
              <span>329 265 6988</span>
            </a>
            <Button
              onClick={(e) => handleNavClick(e, "#preventivo")}
              className="bg-[#5abb3d] hover:bg-[#4a9a32] text-white rounded-full px-6 transition-all hover:-translate-y-1 hover:shadow-lg"
              data-testid="cta-preventivo-btn"
            >
              Richiedi Preventivo
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2 text-[#29383d]"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            data-testid="mobile-menu-btn"
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div
          className="lg:hidden glass border-t border-[#29383d]/10"
          data-testid="mobile-menu"
        >
          <nav className="max-w-7xl mx-auto px-4 py-4 flex flex-col gap-2">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => handleNavClick(e, link.href)}
                className="py-3 px-4 text-[#29383d] font-medium hover:bg-[#5abb3d]/10 rounded-lg transition-colors"
                data-testid={`mobile-nav-link-${link.href.replace('#', '')}`}
              >
                {link.label}
              </a>
            ))}
            <a
              href="tel:+393292656988"
              className="py-3 px-4 flex items-center gap-2 text-[#5abb3d] font-semibold"
              data-testid="mobile-phone-link"
            >
              <Phone className="w-5 h-5" />
              <span>329 265 6988</span>
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
